var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1175,
    height: 963,
    viewBox: "0 0 1175 963",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9242 -76.5218L-172.638 793.731M176.605 -59.6495L-65.9573 810.603M283.285 -42.7773L40.7232 827.475M389.966 -25.9051L147.404 844.348M496.646 -9.03283L254.084 861.22M603.326 7.83941L360.765 878.092M710.007 24.7116L467.445 894.964M816.687 41.5839L574.125 911.837M923.368 58.4561L680.806 928.709M1030.05 75.3283L787.486 945.581M1136.73 92.2006L894.167 962.453M1173.98 136.494L10.4995 -47.5188M1151.74 216.288L-11.7411 32.2751M1129.5 296.082L-33.9817 112.069M1107.26 375.876L-56.2223 191.863M1085.02 455.67L-78.463 271.657M1062.78 535.464L-100.704 351.451M1040.54 615.258L-122.944 431.245M1018.3 695.052L-145.185 511.039M996.058 774.845L-167.425 590.833M973.818 854.639L-189.666 670.627M951.577 934.433L-211.907 750.421",
    stroke: "url(#paint0_radial_1887_2109)",
    strokeWidth: 0.643589
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1887_2109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.894 162.851) rotate(52.4813) scale(909.658 1555.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDA5AE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.bb3b60b2d9516ff4099f4412fde21da8.svg";
export { ForwardRef as ReactComponent };